import {useEffect} from 'react';
import _ from 'lodash';
import {getDetailById} from '@/lib/utils/array';

export const lifecycle = {
  componentDidMount(props: any) {
    const {actions} = props;

    useEffect(() => {
      const id = Number(props.match.params.id);
      const active = props.sales.pages.active;

      if (window.isInitial) {
        (async () => {
          await actions.sales.getOne(id);
        })();
      } else {
        const detail = getDetailById(id, active, 'saleId');
        actions.sales.updateDetail(detail);
      }
    }, []);
  },
};
